import { useListAtsRejectionReasons } from "@/lib/api/generated";

export interface AtsRejectionReason {
  id: string;
  name: string;
}

/**
 * Wraps the connection-scoped generated rejection-reasons query.
 * Returns the preflight result fields so the reject modal (Task 8) can gate
 * the action without an additional fetch.
 */
export function useRejectionReasons(
  connectionId: string | null,
  enabled: boolean,
) {
  const query = useListAtsRejectionReasons(connectionId ?? "", {
    query: { enabled: enabled && !!connectionId },
  });
  const reasons: AtsRejectionReason[] = query.data?.reasons ?? [];
  return {
    reasons,
    isLoading: query.isLoading,
    hasReasons: reasons.length > 0,
    reasonRequired: query.data?.reason_required ?? false,
    emailWarning: query.data?.email_warning ?? null,
    allowed: query.data?.allowed ?? false,
    blockReason: query.data?.block_reason ?? null,
  };
}
